import {getEnvironment} from '@sail/utils';

export const REQUEST_MARKER_HEADER = 'Wrmkch-ky';
export const REQUEST_MARKER_VALUE = 'wrmkch-value';
export const REQUEST_QUERY_PARAM = 'Wrmkcp-ky';
export const REQUEST_QUERY_PARAM_VALUE = 'wrmkcp-value';

const sampleRate = 0.1 / 100; // 0.1% chance to add markers
export function shouldAddMarkers() {
  if (getEnvironment() === 'test') {
    // In test environments, we never add markers
    return false;
  }

  // Random sample condition to determine if markers should be added.
  if (Math.random() < sampleRate) {
    return true;
  }
  return false;
}

export function parseUrl(url: string): URL | undefined {
  try {
    return new URL(url);
  } catch (error) {
    return undefined;
  }
}

function addQueryParamMarkerToUrl(url: string) {
  const u = parseUrl(url);
  if (!u) {
    return url;
  }

  if (u.searchParams.size > 0) {
    // If there are existing search params, we add the marker as a new param
    u.searchParams.set(REQUEST_QUERY_PARAM, REQUEST_QUERY_PARAM_VALUE);
  }

  return u.toString();
}

/**
 * Adds the request markers
 * NOTE: This is only exported for tests. Use `maybeAddRequestMarkers` in production code instead.
 */
export function _addRequestMarkers(
  url: string,
  headers?: Record<string, string>,
  handleQueryParams?: boolean,
): {headers?: Record<string, string>; url: string} {
  return {
    headers: {
      ...headers,
      // Always add the marker header
      [REQUEST_MARKER_HEADER]: REQUEST_MARKER_VALUE,
    },
    url: handleQueryParams ? addQueryParamMarkerToUrl(url) : url,
  };
}

/**
 * Adds the request markers
 */
export function maybeAddRequestMarkers(
  url: string,
  headers?: Record<string, string>,
  {handleQueryParams}: {handleQueryParams?: boolean} = {},
): {headers?: Record<string, string>; url: string} {
  try {
    if (shouldAddMarkers()) {
      return _addRequestMarkers(url, headers, handleQueryParams);
    }
  } catch (error) {
    // we don't really care about errors here, just return the original url and headers
  }
  return {headers, url};
}
